const state = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  postCode: '',
  iAmA: '',
  layout: 'ind-donation' // ind-wildcard, ind-petition, ind-donation, business, school, community
};

const getters = {
  lead: state => state
};

const mutations = {
  setIAmA: (state, value) => {
    state.iAmA = value
  },
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/earth-hour.js